import httpService from "@/core/services/http.service.js";
import serviceCategoryMapper from "@/core/services/helpers/serviceCategoryMapper.js";

// action types
export const GET_SERVICE_CATEGORIES = "getServiceCategories";

// mutations types
export const SET_SERVICE_CATEGORIES = "setServiceCategories";

/**
 * Merges GET /api/b2b/services (categories with nested services) and
 * GET /api/b2b/service-categories (all categories) so empty categories
 * are included with services: [].
 * @param {Array} fromServices
 * @param {Array} fromCategories
 * @return {Array}
 */
function mergeServiceCategoryLists(fromServices, fromCategories) {
    const nested = fromServices || [];
    const flat = fromCategories || [];
    const byId = new Map();

    nested.forEach((cat) => {
        if (cat == null) return;
        byId.set(cat.id, { ...cat, services: cat.services || [] });
    });

    flat.forEach((cat) => {
        if (cat == null) return;
        if (byId.has(cat.id)) {
            const merged = byId.get(cat.id);
            if (merged.image == null && cat.image != null) {
                merged.image = cat.image;
            }
        } else {
            byId.set(cat.id, { ...cat, services: [] });
        }
    });

    const result = [];
    const used = new Set();
    if (flat.length) {
        flat.forEach((cat) => {
            if (cat != null && byId.has(cat.id) && !used.has(cat.id)) {
                result.push(byId.get(cat.id));
                used.add(cat.id);
            }
        });
    } else {
        nested.forEach((cat) => {
            if (cat != null && byId.has(cat.id) && !used.has(cat.id)) {
                result.push(byId.get(cat.id));
                used.add(cat.id);
            }
        });
    }
    byId.forEach((cat, id) => {
        if (!used.has(id)) {
            result.push(cat);
            used.add(id);
        }
    });
    return result;
}

const state = {
    serviceCategories: [],
};

const getters = {
    allServiceCategories(state) {
        return state.serviceCategories;
    },
    getServiceCategory: (state) => (id) =>
        state.serviceCategories.find(
            (serviceCategory) => serviceCategory.id === id
        ),
};

const actions = {
    [GET_SERVICE_CATEGORIES](context) {
        return Promise.all([
            httpService.get("/api/b2b/services"),
            httpService
                .get("/api/b2b/service-categories")
                .catch(() => ({ data: { data: [] } })),
        ]).then(([servicesRes, categoriesRes]) => {
            const nested = servicesRes.data.data;
            const flat = categoriesRes.data && categoriesRes.data.data;
            const merged = mergeServiceCategoryLists(
                nested,
                Array.isArray(flat) ? flat : []
            );
            context.commit(SET_SERVICE_CATEGORIES, merged);
        });
    },
};

const mutations = {
    [SET_SERVICE_CATEGORIES](state, serviceCategories) {
        state.serviceCategories =
            serviceCategoryMapper.mapServiceCategories(serviceCategories);
    },
};

export default {
    state,
    actions,
    mutations,
    getters,
};
